__turbopack_context__.v({
  "icon": "TooltipComponent-module-scss-module__isJCoW__icon",
  "tooltip": "TooltipComponent-module-scss-module__isJCoW__tooltip",
  "tooltipArrow": "TooltipComponent-module-scss-module__isJCoW__tooltipArrow",
  "tooltipBlock": "TooltipComponent-module-scss-module__isJCoW__tooltipBlock",
});
